module.exports = `
  type File {
    url: String
  }
`;
